define("shared/types/image", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.MimeType = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f

  let MimeType;
  _exports.MimeType = MimeType;

  (function (MimeType) {
    MimeType["Png"] = "image/png";
    MimeType["Avif"] = "image/avif";
    MimeType["Webp"] = "image/webp";
    MimeType["Gif"] = "image/gif";
    MimeType["Jpg"] = "image/jpg";
    MimeType["Svg"] = "image/svg";
  })(MimeType || (_exports.MimeType = MimeType = {}));
});